import { defineMessages } from "react-intl";

export const appMessages = defineMessages({
  failedToFetchAppSettings: {
    id: "ac+Y98",
    defaultMessage: "Failed to fetch app settings",
    description: "app settings error",
  },
  appActivated: {
    id: "D/+84n",
    defaultMessage: "App activated",
    description: "snackbar text",
  },
  appDeactivated: {
    id: "USO8PB",
    defaultMessage: "App deactivated",
    description: "snackbar text",
  },
});
